<template>
  <div id="app">
    <!--自動轉到加入好友頁面-->
    <a id="autoclickme" :href="'http://line.me/ti/p/' + this.Uid" target="_blank" title="Wibibi"></a> <!--@974fpddd-->
    <a id='auto' :href="'http://line.me/ti/p/' + this.Uid"></a>
    <!--<p>{{ msg }}</p>-->
    <div>
      <img id="logo" src="./assets/Beauty.jpg">
    </div>
    <div class="buttonrow">
      <button id="closewindowbutton" v-on:click="userPro" :disabled="isDisable">點我索取本期活動優惠</button>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapActions,mapGetters,mapState } from 'vuex'

export default {
  name: 'App',
  data() {
    return {
      keyword: window.location.search.split('keyword=')[1].split('&c')[0],
      c: window.location.search.split('&c=')[1],
      userid: null,
      isDisable: false
    }  
  },
  methods: {
    create: function() {
      this.$store.dispatch('getUserid', 
      {
        t: true
      })
    },
    userPro: function() {
        this.$store.dispatch('getApi', 
        {
          keyword: this.keyword,
          c: this.c
        })
        // 防止重複點擊按鈕
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false
        }, 2000)
      
    },
    channel: function() {
      this.$store.dispatch('getAutoclick', 
      {
        c: this.c
      })
    },
    getId: function() {
      this.$store.dispatch('getID', this.c)
    }
  },
  computed: {
    ...mapGetters({
      Uid: 'Uid'
    })
  },
  mounted() {
    this.getId()
    this.create()
    this.channel()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin-top: 15px;
}
</style>





// WEBPACK FOOTER //
// src/App.vue